
import { Vue, Component, Prop } from 'vue-property-decorator'

import Login from './Login.vue'
import Config from 'shared/components/config/_Config.vue'
import { config } from 'display/config'
import { displayType } from 'shared/util'
import { bus } from 'shared/state/Bus'
import { version } from 'package.json'

@Component({ components: { Config, Login }})
export default class ConfigModal extends Vue {

	config = config
	loggedIn = false
	activeTab = ''
	isVisible = false
	version = version

	get page() {
		return displayType(this.$route.name || undefined)
	}

	toggle() {
		this.isVisible = !this.isVisible
	}

	created() {
		this.$root.$on('toggle-config', this.toggle)
		try {
			this.loggedIn = !!localStorage.getItem('ERGLoggedIn')
		} catch(e) {
			this.loggedIn = false
		}
	}

	destroyed() {
		this.$root.$off('toggle-config', this.toggle)
	}

	tabChanged(newVal: string) {
		this.activeTab = newVal
	}
}
